(function() {
    'use strict';
    var controllerId = 'auditListCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', auditListCtrl]);

    function auditListCtrl(common, datacontext, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        if ( !angular.isDefined($scope.audit_sub_type_id) ){
            $scope.audit_sub_type_id = "";
        }

        $scope.audit_limt = "10";

        /****
        requires parent scope to pass
         $scope.audit_link_id,
         $scope.audit_type_id,
         $scope.audit_sub_type_id
        ****/

        // allows other controllers to refresh auditLog
        //
        // $rootScope.$on("refreshAuditLog", getAuditLog() );


        $scope.$on('refreshAuditLog', function (event, data) {
            getAuditLog(0);
        });

        $scope.filterSubtype = function() {
            $scope.audit_sub_type_id = $scope.audit_subtype_id_filter;
            getAuditLog(1);
        };

        $scope.filterLimit = function() {
            $scope.audit_limt = $scope.audit_limit;
            getAuditLog(1);
        };

        activate();

        function activate() {
            var promises = [getAuditLog(),getAuditSubTypes()];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Location List View');
                });
        }

        function getAuditSubTypes() {

            var filter = {
                audit_type_id:$scope.audit_type_id
            };

            return datacontext.getAuditSubTypes(filter).then(function(httpResult) {
                vm.AuditSubTypes = httpResult.data.data;
            });
        }

        function getAuditLog(log) {

            var filter = {
                link_id:$scope.audit_link_id,
                audit_type_id:$scope.audit_type_id,
                audit_subtype_id:$scope.audit_sub_type_id,
                limit:$scope.audit_limt
            };
            console.log($scope.audit_type_id);
            if(log === 1 || ($scope.audit_type_id !== 3 && $scope.audit_type_id !== 1 && $scope.audit_type_id !== 4) ){
            	return datacontext.getAuditLog(filter).then(function(httpResult) {
                    vm.audit_log = httpResult.data.data;
                    vm.audit_current_time = httpResult.data.CURRENTTIME;
                });
            }else{
                vm.audit_log = [];
            	vm.audit_log.audit_subtype = '';
            	vm.audit_log.log = '';
            	vm.audit_log.created_on = '';
            	vm.audit_log.created_by = '';
            }

        }
    }
})();
